import { configureStore } from '@reduxjs/toolkit';
import { createLogger } from 'redux-logger';
import { baseApi } from 'services/api';
import { isProduction } from 'utils/envUtils';
import rootReducer from './reducers';
import { LocalStorage } from 'services/storage';
import { LocalStorageKeysEnum } from 'constants/common';
import { initialState } from 'containers/app/appSlice';
import { MerchantTeam, UserDetails } from 'containers/app/app.model';

const middlewareGroup = [baseApi.middleware];

if (!isProduction) {
  middlewareGroup.push(createLogger({ collapsed: true, diff: true }));
}

// Load persisted state from localStorage
const loadState = () => {
  try {
    const currentTeam = LocalStorage.get('currentTeam') as MerchantTeam | null;
    const userDetails = LocalStorage.get(LocalStorageKeysEnum.USER_DETAILS) as UserDetails | null;

    if (currentTeam || userDetails) {
      return {
        rootReducer: {
          app: {
            ...initialState,
            currentTeam: currentTeam || initialState.currentTeam,
            userDetails: userDetails || initialState.userDetails
          }
        }
      };
    }
    return undefined;
  } catch (err) {
    return undefined;
  }
};

const preloadedState = loadState();

export const store = configureStore({
  reducer: {
    rootReducer,
    [baseApi.reducerPath]: baseApi.reducer
  },
  middleware: getDefaultMiddleware => getDefaultMiddleware().concat(middlewareGroup),
  preloadedState,
  devTools: !isProduction
});

export type AppDispatch = typeof store.dispatch;
